<template>
  <div class="map-wrapper">
  <div class="google-map" ref="googleMap">
  </div>
  <button @click="updateMapZoom"></button>
  <div class="google-map--zoom">
    <div class="google-map--zoom-in" ref="zoomIn">+</div>
    <div class="google-map--zoom-out" ref="zoomOut">-</div>
  </div>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'
import MarkerClusterer from '@googlemaps/markerclustererplus'
// TODO: replace with real data
import mapStyles from './mapStyles.json'

export default {
  name: 'Map',
  data: () => ({
    google: null,
    map: null,
    markers: [],
    markerCluster: null,
    selectedMarker: null,
    popup: null,
    mapOptions: {
      zoom: 6,
      center: {
        lat: 40.3450083,
        lng: -1.1185173
      },
      // zoomControl: true,
      disableDefaultUI: true,
      scrollwheel: false,
      mapTypeId: 'Styled',
      mapTypeControl: false,
      draggable: true,
      // zoomControlOptions: { position: null }
    },
    clusterOptions: {
      maxZoom: 18,
      // gridSize: 52,
      // minimumClusterSize: 1,
      styles: [{
        url: require('../../images/search/cluster_red.svg'),
        height: 50,
        width: 50,
        textColor: '#fff',
        textSize: 14
      }]
    },
    bounds: {
      distance: null
    },
    // TODO: take this key from env?
    apiKey: 'AIzaSyDP9-Ef5Li4eyrSao_7kifAnmZzDuRZocY'
  }),
  props: ['data', 'returnCenters'],
  components: {
  },
  computed: {
  },
  async mounted () {
    const loader = await new Loader({
      apiKey: this.apiKey
    })
    this.google = await loader.load()
    this.google = window.google
    this.initMap()

    // Method to fire map center update from TypeSearch component
    this.$root.$on('updateMapCenter', () => {
        // your code goes here
        this.updateMapCenter()
    })
    // Method to fire map center update from TypeSearch component
    this.$root.$on('updateMapZoom', (level) => {
        // your code goes here
        this.updateMapZoom(level)
    })

    this.$root.$on('resetMap', () => {
        // your code goes here
        this.resetMap()
    })

  },
  created () {

    // Get Current string
    var queryString = window.location.search
    var urlParams = new URLSearchParams(queryString)

    // Set lat/lng from url, if not present check for value in store, if not present then use window default value
    this.mapOptions.center.lat = urlParams.get('lat') ? Number(urlParams.get('lat')) : this.$store.state.rent.lat ? this.$store.state.rent.lat : window.default_bounds.lat
    this.mapOptions.center.lng = urlParams.get('lng') ? Number(urlParams.get('lng')) : this.$store.state.rent.lng ? this.$store.state.rent.lng : window.default_bounds.lng

    // Set zoom level if locality is present, otherwise default to window default value
    this.mapOptions.zoom = this.$store.state.rent.location_type === 'locality' ? 10 : this.$store.state.rent.location_type === 'exact' ? 16 : window.default_bounds.zoom

  },
  watch: {
    // Watch for changes to listings data and update markers
    'data': {
      handler (value) {
        this.updateMarkers()
      },
      deep: true
    }
  },
  methods: {
    initMap () {
      const mapContainer = this.$refs.googleMap
      if (this.returnCenters) {
        this.clusterOptions.maxZoom = 18
        this.clusterOptions.styles[0].url = window.map_cluster_path
      }
      // this.mapOptions.zoomControlOptions.position = google.maps.ControlPosition.TOP_RIGHT
      this.map = new self.google.maps.Map(mapContainer, this.mapOptions)
      var styledMapType = new this.google.maps.StyledMapType(mapStyles, {
        name: 'Styled'
      })
      this.map.mapTypes.set('Styled', styledMapType)
      // this.initMarkers()
      this.initBounds()
      this.initControls()
    },
    updateMapCenter () {

      var queryString = window.location.search
      var urlParams = new URLSearchParams(queryString)

      var mapCenter = {
        lat: Number(this.$store.state.rent.lat),
        lng: Number(this.$store.state.rent.lng) 
      }
      this.map.setCenter(mapCenter)
    },
    updateMapZoom (level) {
      let zoom = 16
      if (level) {
        zoom = level
      }

      this.map.setZoom(zoom)
    },
    resetMap () {
        var defaults = window.default_bounds
        this.map.setZoom(defaults.zoom)
        var mapCenter = {
          lat: defaults.lat,
          lng: defaults.lng 
        }
        this.map.setCenter(mapCenter)
    },
    initControls () {
     var self  = this
     this.google.maps.event.addDomListener(this.$refs.zoomOut, 'click', function() {
        var currentZoomLevel = self.map.getZoom()
        if (currentZoomLevel != 0) {
           self.map.setZoom(currentZoomLevel - 1)
        }     
      })
      this.google.maps.event.addDomListener(this.$refs.zoomIn, 'click', function() {
        var currentZoomLevel = self.map.getZoom()
        if (currentZoomLevel != 21) {
          self.map.setZoom(currentZoomLevel + 1)
        }
      })
    },
    updateMarkers () {
      // Clear markers and clusters if they exist
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null)
      }
      if (this.markerCluster) {
        this.markerCluster.clearMarkers()
        this.markerCluster.setMap(null)
        this.markerCluster = null
      }
      if (this.marker) {
        this.marker.setMap(null)
        this.marker = null
      }
      this.markers = []
      // Set new markers
      this.initMarkers()
    },
    initBounds () {
      var self = this
      var mapupdater
      this.google.maps.event.addListener(this.map, 'bounds_changed', debounceMap)
      // Only fire bounds changed after 0.5s
      function debounceMap () {
        clearTimeout(mapupdater)
        mapupdater = setTimeout(getDistance, 500)
      }
      // Get the new bounds
      function getDistance () {
        var bounds = self.map.getBounds()
        var center = bounds.getCenter()
        var sw = bounds.getSouthWest()
        var ne = bounds.getNorthEast()

        // Add map center to store
        self.$store.commit('lat', center.lat())
        self.$store.commit('lng', center.lng())

        // Add map bounds to store
        var boundsObject = {
          latitude: ne.lat(),
          longitude: ne.lng(),
          latitude2: sw.lat(),
          longitude2: sw.lng()
        }
        // self.$store.commit('distance', self.bounds.distance)
        self.$store.commit('bounds', boundsObject)
      }
    },
    initMarkers () {
      var self = this
      var image
      var mapData = this.data

      for (var i = 0; i < mapData.length; i++) {
        var latLng = new this.google.maps.LatLng(mapData[i].node.latitude,
          mapData[i].node.longitude)

        if (self.returnCenters) {
          // TODO: Get custom marker from listing
          image = {
            url: mapData[i].node.mapClusterLogoUrl ? mapData[i].node.mapClusterLogoUrl : require('../../images/search/marker.svg'),
            scaledSize: new this.google.maps.Size(50, 68)
          }
        } else {
          image = {
            url: require('../../images/search/marker.svg'),
            scaledSize: new this.google.maps.Size(25, 34)
          }
        }
        /*
        // Offset markers in same position
        var finalLatLng = latLng
        for (i = 0; i < this.markers.length; i++) {
          var existingMarker = this.markers[i]
          var pos = existingMarker.getPosition()
          // if a marker already exists in the same position as this marker
          if (latLng.equals(pos)) {
            // update the position of the coincident marker by applying a small multiplier to its coordinates
            var newLat = latLng.lat() + (Math.random() - 0.5) / 3000
            var newLng = latLng.lng() + (Math.random() - 0.5) / 3000
            finalLatLng = new this.google.maps.LatLng(newLat, newLng)
          }
        }
        */

        this.marker = new this.google.maps.Marker({
          position: latLng,
          icon: image
        })

        var markerContent = mapData[i].node

        this.marker.content = markerContent

        this.google.maps.event.addListener(this.marker, 'click', function (e) {
          // Set the content of the InfoBubble or InfoWindow
          // They both have a function called setContent
          // marker.setMap(map);
          self.selectedMarker = this.content
          self.initPopup(this.getPosition().lat(), this.getPosition().lng(), markerContent)
          self.map.setCenter(this.getPosition())
        })
        this.markers.push(this.marker)
      }
      this.markerCluster = new MarkerClusterer(this.map, this.markers, this.clusterOptions)
      // Add markers to map
      for (var s = 0; s < this.markers.length; s++) {
        this.markers[s].setMap(this.map)
      }
    },
    initPopup (lat, lng) {
      var self = this
      /**
       * A customized popup on the map.
       */
      class Popup extends this.google.maps.OverlayView {
        constructor (position, content) {
          super()
          this.position = position
          content.classList.add('popup-bubble')
          // This zero-height div is positioned at the bottom of the bubble.
          const bubbleAnchor = document.createElement('div')
          bubbleAnchor.classList.add('popup-bubble-anchor')
          bubbleAnchor.appendChild(content)
          // This zero-height div is positioned at the bottom of the tip.
          this.containerDiv = document.createElement('div')
          this.containerDiv.classList.add('popup-container')
          this.containerDiv.appendChild(bubbleAnchor)
          // Optionally stop clicks, etc., from bubbling up to the map.
          Popup.preventMapHitsAndGesturesFrom(this.containerDiv)
        }

        // Called when the popup is added to the map.
        onAdd () {
          document.querySelectorAll('.popup-container').forEach(e => e.remove())
          this.getPanes().floatPane.appendChild(this.containerDiv)
          // Add close listener
          document.querySelector('.js-close').addEventListener('click', function (e) {
            self.popup.onRemove()
          })
        }

        // Called when the popup is removed from the map.
        onRemove () {
          if (this.containerDiv.parentElement) {
            this.containerDiv.parentElement.removeChild(this.containerDiv)
          }
        }

        // Called each frame when the popup needs to draw itself.
        draw () {
          const divPosition = this.getProjection().fromLatLngToDivPixel(
            this.position
          )
          // Hide the popup when it is far out of view.
          const display =
            Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
              ? 'block'
              : 'none'

          if (display === 'block') {
            this.containerDiv.style.left = divPosition.x + 'px'
            this.containerDiv.style.top = divPosition.y + 'px'
          }

          if (this.containerDiv.style.display !== display) {
            this.containerDiv.style.display = display
          }
        }
      }
      // Create popup container
      var popupContent = document.createElement('div')
      popupContent.className = 'popup-content'

      if (this.returnCenters) {
        popupContent.innerHTML = `
          <div class="popup-content--image">
            <a href="/search/centre/${this.selectedMarker.slug}">
              <img src="${this.selectedMarker.featuredImageUrl}">
            </a>
          </div>
          <button class="popup-content--close js-close">&times;</button>
          <div class="popup-content--text">
            <a href="/search/centre/${this.selectedMarker.slug}">
              <div class="popup-content--title">${this.selectedMarker.title}</div>
              <div class="popup-content--address">${this.selectedMarker.address}</div>
            </a>
          </div>
        `
      } else {
        popupContent.innerHTML = `
          <div class="popup-content--image">
            <a href="/rent/${this.selectedMarker.slug}">
              <img src="${this.selectedMarker.image1Url}">
            </a>
          </div>
          <button class="popup-content--close js-close">&times;</button>
          <div class="popup-content--text">
            <a href="/rent/${this.selectedMarker.slug}">
              <div class="popup-content--title">${this.selectedMarker.title}</div>
              <div class="popup-content--price">€${this.selectedMarker.price}</div>
            </a>
          </div>
        `
      }

      // document.body.appendChild(d)
      this.popup = new Popup(
        new this.google.maps.LatLng(lat, lng),
        popupContent
      )
      this.popup.setMap(this.map)
    },
    closePopup () {
      this.popup.setMap(null)
      this.popup = null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../scss/global/includes";


.google-map, .google-map * {
  outline: none;
}
.google-map {
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  .cluster {
    display: flex;
    align-items: center;
    span {
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      position: relative;
    }
  }
}
.google-map--zoom {
  position: absolute;
  top: 20px;
  right: 20px;
  @include breakpoint(tablet-landscape) {
    display: none;
  }
}

.google-map--zoom-in, .google-map--zoom-out {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: $primary;
  color: #FFFFFF;
  font-size: 34px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}

.google-map--zoom-in {
  margin-bottom: 5px;
}

/* The popup bubble styling. */
.popup-bubble {
  /* Position the bubble centred-above its parent. */
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -100%);
  /* Style the bubble. */
  background-color: white;
  padding: 0;
  border-radius: 20px;
  font-family: sans-serif;
  overflow-y: auto;
  width: 260px;
  box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.5);
}

.popup-content--close {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #FFFFFF;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
}

.popup-content--image {
  height: 180px;
  background: $soft-light;
  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
}

.popup-content--text {
  padding: 20px 15px;
  width: 100%;
  font-size: 14px;
}

.popup-content--title {
  width: 100%;
  margin-bottom: 5px;
  color: $primary;
  line-height: 1.1;
  font-family: $font-bold;
}

.popup-content--price {
  width: 100%;
}

.popup-content--address {
  width: 100%;
  font-size: 10px;
}

/* The parent of the bubble. A zero-height div at the top of the tip. */
.popup-bubble-anchor {
  /* Position the div a fixed distance above the tip. */
  position: absolute;
  width: 100%;
  bottom: 40px;
  left: 0;
}

/* This element draws the tip. */
.popup-bubble-anchor::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  /* Center the tip horizontally. */
  transform: translate(-50%, 0);
  /* The tip is a https://css-tricks.com/snippets/css/css-triangle/ */
  width: 0;
  height: 0;
  /* The tip is 8px high, and 12px wide. */
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid white;
}

/* JavaScript will position this div at the bottom of the popup tip. */
.popup-container {
  cursor: auto;
  height: 0;
  position: absolute;
  /* The max width of the info window. */
  width: 200px;
  animation: fadeIn ease 1s;
}

@keyframes fadeIn {
  0% {
    opacity:0;
  }
  100% {
    opacity:1;
  }
}
</style>
